/*
Refactor driver list
returns driver list
 */
export const refactorDriversUtil = (drivers) => {
    return drivers?.map(driver => RefactorDriverUtil(driver))
}

/*
Refactor driver item to match UI object
returns driver item
 */
const RefactorDriverUtil = (driver) => {
    return {
        ...driver,
        idNumber: driver?.nationalId ?? 'N/A',
        fullName: driver?.engFullName,
        yearOfBirth: driver?.gregDob?.split('-')[2],
        gender: driver?.genderName ?? driver?.genderCode
    };
}